import {orders} from './index';

export default function(_value) {
  if (!arguments.length) return this.__attrs__.sortByValue;
  if (typeof _value !== 'string' || !orders.find(o => o === _value)) {
    _value = 'natural';
  }
  this.__attrs__.sortByValue = _value;
  return this;
}


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/sortable/sortByValue.js